import api from './api';

export const getPocOwners = async () => {
  const response = await api.get('/poc-owners/');
  return response.data;
};

export const getMyPocOwnerProfile = async () => {
  const response = await api.get('/poc-owners/me');
  return response.data;
};

export const getMyPocOwnerProjects = async () => {
  const response = await api.get('/poc-owners/me/projects');
  return response.data;
};

export const getMyPocOwnerStudents = async () => {
  const response = await api.get('/poc-owners/me/students');
  return response.data;
};

// Students the caller may grant matcher access to. Role-aware server-side: a
// POC owner gets their own students, a super admin or manager gets everyone.
// Deliberately not /poc-owners/me/students — that route is poc_owner-only and
// 403s for the admins who now share this screen.
export const getCompMatcherCandidates = async () => {
  const response = await api.get('/students/comp-matcher/candidates');
  return response.data;
};

export const updateStudentCompMatcher = async (studentId, enabled, projectId = null) => {
  const response = await api.patch(`/students/${studentId}/comp-matcher`, {
    comp_matcher_enabled: enabled,
    comp_matcher_project_id: projectId,
  });
  return response.data;
};
